import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import styled from './styled';
import {
  ChannelMessageWrap,
  Info,
  ActionMenuWrap,
  ContextMenu,
} from '../styled';
import { messageDateFormat } from 'helpers/date-time';
import { Mixpanel } from 'helpers/Mixpanel';
import { extractChatParticipant } from '../../../../../helpers/community-util';
import GenericConfirmActionModal from 'pages/CommunityMergeFeed/CreateFeed/GenericConfirmActionModal';

class ChatComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: null,
      receiveNewChatMessage: false,
      showArchiveChat: false,
    };

    this._isMounted = false;
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    const { locations, locationId, } = this.props;

    this._isMounted = true;
    if (locations && locations.length > 0) {
      const currentLocation = locations.filter((location) => location.id === parseInt(locationId));
      if (currentLocation && currentLocation.length > 0) {
        this.setState({ location: currentLocation[0] });
      }
    }

    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keydown', this.handleEscapePress);
  }

  componentDidUpdate(prevProps, prevState) {
    const { active, chat, handleClick, location, locations, locationId, } = this.props;

    if (prevProps.locations !== locations) {
      if (locations && locations.length > 0) {
        const currentLocation = locations.filter((location) => location.id === parseInt(locationId));
        if (currentLocation && currentLocation.length > 0) {
          this.setState({ location: currentLocation[0] });
        }
      }
    }

    if (prevProps.chat !== chat) {
      if (chat && chat.receiveNewChatMessage && chat.receiveNewChatMessage === true) {
        this.setState({ receiveNewChatMessage: true });
      } else {
        this.setState({ receiveNewChatMessage: false });
      }
    }

  }

  componentWillUnmount() {
    this._isMounted = false;

    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleEscapePress);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ showMenuFor: null });
    }
  };

  handleEscapePress = (event) => {
    if (event.key === 'Escape') {
      this.setState({ showMenuFor: null });
    }
  };

  handleArchiveChat = () => {
    const { chat } = this.props;
    this.props.onDelete?.(chat.id)
    this.toggleModal('showArchiveChat', false);
  };

  toggleModal = (key, value) => {
    this.setState({ [key]: value });
  };

  render() {
    const { active, chat, handleClick, } = this.props;
    const { location, receiveNewChatMessage, showArchiveChat } = this.state;
    const approvedBadge = '/icons/verified-badge-icon.svg';
    const condition = false;

    const dateTimeInfo = messageDateFormat(chat.updated_at);

    const participant = extractChatParticipant(chat);
    const sessionUser = participant ? participant.owner : null;
    const sessionUserName = sessionUser ? `${sessionUser.first_name} ${sessionUser.last_name}` : '';
    let avatarUrl = '';
    if (sessionUser && sessionUser.thumb_url) {
      avatarUrl = sessionUser.thumb_url;
    } else {
      avatarUrl = '/icons/default-profile-thumb.svg';
    }

    let lastContent = '';
    if (chat && chat.latest_message) {
      lastContent = chat.latest_message;
    }
    return (
      <ChannelMessageWrap
        modifiers={active ? 'active' : null}
        onClick={() => {
          handleClick(chat.id);
          Mixpanel.track('Click chat sessios feed', { 'chat_session_id': chat.id });
        }}
      >
        <styled.ChannelAvatar src={avatarUrl} />

        <ActionMenuWrap
          ref={this.wrapperRef}
          className={this.state.showMenuFor === chat.id ? 'menu-open' : ''}
          alwaysVisible={this.state.showMenuFor === chat.id}
          onClick={(e) => {
            e.stopPropagation();
            this.setState((prevState) => ({
              showMenuFor: prevState.showMenuFor === chat.id ? null : chat.id
            }));
          }}
        >
          <img src="/icons/ellipses-icon-h.svg" alt="More" />
          {this.state.showMenuFor === chat.id && (
            <ContextMenu>
              <div onClick={() => this.toggleModal('showArchiveChat', true)}>Delete Chat</div>
              {/* <div onClick={() => this.props.onMute?.(chat.id)}>Mute session</div> */}
            </ContextMenu>
          )}
        </ActionMenuWrap>

        <Info>
          <styled.TopLineWrap>
            <styled.Name>{sessionUserName}</styled.Name>
            {/* {condition && <styled.ApprovedBadge src={approvedBadge} />} */}
            <styled.Time>{dateTimeInfo}</styled.Time>
          </styled.TopLineWrap>
          <styled.BottomLineWrap>
            <styled.LatestContent>{lastContent}</styled.LatestContent>
            {receiveNewChatMessage && <styled.NewPostIndicator />}
          </styled.BottomLineWrap>
        </Info>

        {showArchiveChat && (
          <GenericConfirmActionModal
            title="Delete Chat"
            message="Would you like to delete this conversation? This conversation will be deleted from all the of your devices."
            confirmLabel="Delete Chat"
            actionType="leave"
            onCancel={() => this.toggleModal('showArchiveChat', false)}
            onConfirm={this.handleArchiveChat}
          />
        )}
      </ChannelMessageWrap>
    );
  }
}

ChatComponent.propTypes = {
  //fetchPosts: PropTypes.func.isRequired,

};

export default injectIntl(ChatComponent);



